import React, { useEffect, useState } from "react";
import { useSettings } from "../hooks/useSettings";

const ParallaxHeroSection = ({
    backgroundKey = "hero",
    title,
    subtitle,
    height = "h-96",
    children,
}) => {
    const { theme } = useSettings();
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setOffset(window.scrollY * 0.5);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const backgroundImage =
        theme?.coverImages?.[backgroundKey] || "/assets/images/hero-bg.jpg";

    return (
        <div
            className={`${height} relative overflow-hidden flex items-center justify-center`}
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
                filter:" brightness(0.55)",
            }}
        >
            {/* Parallax effect overlay */}
            <div
                className="absolute inset-0 bg-black bg-opacity-50"
                style={{
                    transform: `translateY(${offset}px)`,
                }}
            />

            {/* Content */}
            <div className="relative z-10 text-center text-white px-4">
                {title && (
                    <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
                        {title}
                    </h1>
                )}
                {subtitle && (
                    <p className="text-lg md:text-xl drop-shadow-lg">
                        {subtitle}
                    </p>
                )}
                {children}
            </div>
        </div>
    );
};

export default ParallaxHeroSection;
